import { useEffect, useRef, useState } from "react";
import i18n from "i18next";
import styles from "./styles";
import { useAppContext } from "../../context";
import { ReactComponent as DownIcon } from "../../assets/down.svg";
import { ReactComponent as RwFlagIcon } from "../../assets/rw.svg";
import { ReactComponent as GbFlagIcon } from "../../assets/gb.svg";

const languages = [
  {
    code: "en",
    nativeName: "English",
    icon: <GbFlagIcon className={styles.flagIcon} />,
  },
  {
    code: "rw",
    nativeName: "Kinyarwanda",
    icon: <RwFlagIcon className={styles.flagIcon} />,
  },
];

function LanguageSwitcher({ onChangeLanguage }) {
  const { language, setLanguage } = useAppContext();
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropDownOpen(false);
      }
    };

    if (isDropDownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropDownOpen]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    setIsDropDownOpen(false);
    if (onChangeLanguage) onChangeLanguage();
  };

  const showNativeName = (lng) => {
    for (const language of languages) {
      if (language.code === lng)
        return (
          <span className={styles.btnContent}>
            {language.icon} {language.nativeName}
          </span>
        );
    }
  };

  return (
    <div className={styles.selectContainer} ref={dropdownRef}>
      <button
        className={styles.select}
        type="button"
        onClick={() => setIsDropDownOpen((prevState) => !prevState)}
      >
        {showNativeName(language)} <DownIcon className={styles.dropDownIcon} />
      </button>
      <div
        className={`${styles.listContainer} ${isDropDownOpen ? "h-20" : "h-0"}`}
      >
        <ul className={styles.languagesList}>
          {languages.map((lng) => (
            <li
              key={lng.code}
              onClick={() => handleLanguageChange(lng.code)}
              className={styles.language}
            >
              {lng.icon} {lng.nativeName}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LanguageSwitcher;
